import { useEffect, useState } from "react";

import QRCode from "react-qr-code";
import Container from "@mui/material/Container";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import { isMobile } from "react-device-detect";

import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import {
  StripedTableCell,
  StripedTableHeadCell,
  StripedTableRow,
} from "../../components/StripedTable";

import HeaderText from "../../components/HeaderText";
import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import ProgressBar from "../../components/ProgressBar";

import { showError } from "../../components/ATPDialogs";

import {
  getBathroomPass,
  encryptReturnPass,
  PASS_QR_KEY,
} from "../../services/PassService";
import { getQrBaseUrl } from "../../services/QrService";
import SETTINGS from "../../settings.json";

const PassReturnQr = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const [showProgress, setShowProgress] = useState(false);
  const [_searchPerformed, setSearchPerformed] = useState(false);
  const [_qrUrl, setQrUrl] = useState("");

  const [_teacher, setTeacher] = useState({
    last_name: "",
    first_name: "",
  });

  useEffect(() => {
    initContent();
  }, []);

  const initContent = () => {
    setShowProgress(true);

    const promises = [
      getBathroomPass(_school, _jwt),
      getQrBaseUrl(_school, _jwt),
    ];

    Promise.all(promises).then((results) => {
      let result = results[0];

      if (result.detail != null) {
        showError("Unable to Generate QR", result.detail);
        return;
      }

      setTeacher(result.data.teacher);

      const encrypted = encryptReturnPass(PASS_QR_KEY, result.data.teacher.eid);

      const baseUrl = results[1];
      setQrUrl(baseUrl + `/student/pass/qr/return/${encrypted}`);
      setShowProgress(false);
      setSearchPerformed(true);
    });
  };

  const getQrCode = () => {
    if (isMobile) {
      return (
        <QRCode
          size={256}
          style={{ height: "auto", maxWidth: "80%", width: "80%" }}
          value={_qrUrl}
          viewBox={`0 0 256 256`}
        />
      );
    } else {
      return <QRCode size={680} value={_qrUrl} />;
    }
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Return QR Code" showBack={true} />
        <ProgressBar showProgress={showProgress} />

        <Box sx={{ display: _searchPerformed ? "" : "none" }}>
          <HeaderText text={`Return QR Code`} />
          <Table size="small">
            <TableBody>
              <StripedTableRow>
                <StripedTableHeadCell>Teacher:</StripedTableHeadCell>
                <StripedTableCell>
                  {_teacher.last_name}, {_teacher.first_name}
                </StripedTableCell>
              </StripedTableRow>
            </TableBody>
          </Table>
          <p style={{ textAlign: "center" }}>{getQrCode()}</p>
          <p>
            <a href={_qrUrl}>Link</a> - {SETTINGS.version}
          </p>
        </Box>
      </Container>
    </>
  );
};

export default PassReturnQr;
